const breakPoint = 767;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();




// ------------------------------------------------------------------------
// preLoad
// ----- BOTH
// ------------------------------------------------------------------------
const preLoad = () => {
  $(window).on('load' , function() {
    $("body").removeClass("preload");
  });
};

// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^='#']").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
};




// ------------------------------------------------------------------------
// togglePagetop
// ----- BOTH
// ------------------------------------------------------------------------
const togglePagetop = () => {
  $(window).on("load scroll", function() {
    let scrollHeight = $(this).scrollTop();
    if (scrollHeight > 300) {
      $(".st-Pagetop").addClass("visible");
    } else {
      $(".st-Pagetop").removeClass("visible");
    }
  });
};


// ------------------------------------------------------------------------
// toggleMenu
// ----- BOTH
// ------------------------------------------------------------------------
const toggleMenu = () => {
  $('.st-Header .hamburger').on('click', function() {
    $(this).toggleClass("open");
    $(".st-Header nav").toggleClass("open");
    $(".st-Header_Inner").toggleClass("open");
  });
};

// ------------------------------------------------------------------------
// scrollAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollAnime = () => {
  $(window).on('scroll load', function() {
    $('.anim-sc').each(function() {
      let targetPos = $(this).offset().top;
      let scrollPos = $(window).scrollTop();
      let windowHeight = $(window).height();
      if (scrollPos > targetPos - windowHeight + windowHeight / 8) {
        $(this).addClass("animated")
      }
    });
  });
};

// ------------------------------------------------------------------------
// voicePlayer
// ----- BOTH
// ------------------------------------------------------------------------
const voicePlayer = () => {
  $('.voice-item a').on('click', function() {
    $(this).children('audio').get(0).play();
  });
};



export {
  preLoad,
  anchorLink,
  togglePagetop,
  toggleMenu,
  scrollAnime,
  voicePlayer
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js